import React, { useEffect } from "react";

import Layout from "../components/layoutBlack";
import Breadcrumbs from "../components/breadcrumbs";
import WholesaleRegistrationForm from "../components/wholesaleRegistrationForm";

const WholesaleRegistration = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Layout>
                {/* Breadcrumbs */}
                <div className="container p-t-80 p-b-10">
                    <Breadcrumbs />
                </div>

                {/* Page Heading */}
                <section className="bg0 p-t-30 p-b-20">
                    <div className="container">
                        <div className="txt-center">
                            <h2 className="ltext-105 cl2">
                                Wholesale Registration
                            </h2>

                            <p className="stext-115 cl6 p-t-15">
                                Apply for access to Molu Wellness
                                wholesale products and pricing.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Main Content */}
                <section className="full-page-section bg0 p-t-30 p-b-125">
                    <div className="container">
                        <div className="flex-w flex-tr">
                            {/* Registration Form */}
                            <div className="size-210 bor10 p-lr-50 p-t-55 p-b-70 p-lr-15-lg w-full-md">
                                <WholesaleRegistrationForm />
                            </div>

                            {/* Wholesale Information */}
                            <div className="size-210 bor10 flex-w flex-col-m p-lr-70 p-tb-50 p-lr-15-lg w-full-md">
                                <div className="w-full">
                                    <h3 className="mtext-110 cl2 p-b-25">
                                        Become a Molu Wholesale Partner
                                    </h3>

                                    <p className="stext-115 cl6 p-b-30">
                                        Our wholesale program is designed
                                        for qualified retailers, salons,
                                        spas, wellness professionals, and
                                        other businesses interested in
                                        offering Molu Wellness products.
                                    </p>

                                    <div className="flex-w w-full p-b-35">
                                        <span className="fs-18 cl5 txt-center size-211">
                                            <span className="lnr lnr-store"></span>
                                        </span>

                                        <div className="size-212 p-t-2">
                                            <span className="mtext-110 cl2">
                                                Business Information
                                            </span>

                                            <p className="stext-115 cl6 size-213 p-t-12">
                                                Provide your company name,
                                                business address, phone
                                                number, and website, if
                                                available.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex-w w-full p-b-35">
                                        <span className="fs-18 cl5 txt-center size-211">
                                            <span className="lnr lnr-license"></span>
                                        </span>

                                        <div className="size-212 p-t-2">
                                            <span className="mtext-110 cl2">
                                                Resale Certificate
                                            </span>

                                            <p className="stext-115 cl6 size-213 p-t-12">
                                                You may upload your resale
                                                certificate as a PDF.
                                                Tax-exempt status will not
                                                be activated until the
                                                certificate is reviewed.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex-w w-full p-b-35">
                                        <span className="fs-18 cl5 txt-center size-211">
                                            <span className="lnr lnr-hourglass"></span>
                                        </span>

                                        <div className="size-212 p-t-2">
                                            <span className="mtext-110 cl2">
                                                Application Review
                                            </span>

                                            <p className="stext-115 cl6 size-213 p-t-12">
                                                Registering creates an
                                                account, but wholesale
                                                pricing becomes available
                                                only after your application
                                                is approved.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex-w w-full p-b-35">
                                        <span className="fs-18 cl5 txt-center size-211">
                                            <span className="lnr lnr-envelope"></span>
                                        </span>

                                        <div className="size-212 p-t-2">
                                            <span className="mtext-110 cl2">
                                                Existing Customers
                                            </span>

                                            <p className="stext-115 cl6 size-213 p-t-12">
                                                If your email is already
                                                connected to a previous
                                                purchase, we will send an
                                                email verification link
                                                before creating login
                                                access.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex-w w-full">
                                        <span className="fs-18 cl5 txt-center size-211">
                                            <span className="lnr lnr-question-circle"></span>
                                        </span>

                                        <div className="size-212 p-t-2">
                                            <span className="mtext-110 cl2">
                                                Wholesale Support
                                            </span>

                                            <p className="stext-115 cl1 size-213 p-t-12">
                                                <a
                                                    href="mailto:support@molu.co"
                                                    className="cl1"
                                                >
                                                    support@molu.co
                                                </a>
                                            </p>

                                            <p className="stext-115 cl1 size-213 p-t-8">
                                                <a
                                                    href="tel:+19722838880"
                                                    className="cl1"
                                                >
                                                    +1 972 283 8880
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default WholesaleRegistration;